import React from 'react';
import {connect} from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import propTypes from "prop-types";

const PrivateRoute = ({
    component: Component = null,
    render: Render = null,
    auth,
    ...rest
}) => {
    let savedUser = localStorage.getItem(`logged_user`);
    let user = savedUser && JSON.parse(savedUser);
    return (
    <Route 
        { ...rest }
        render={ props => user?.isAuthenticated ? (
            Render ? (
                Render(props)
              ) : Component ? (
                <Component {...props} />
              ) : <Redirect to="/" />
            ) : <Redirect to="/" /> 
             }
    />
);
}

PrivateRoute.propTypes = {
    auth: propTypes.object.isRequired,
};

const mapState = ({ platform: {auth} }) => {
    return {
        auth
    }
};

export default connect(mapState)(PrivateRoute);
